import React, { useState } from 'react'

export const ExpandButton = ({
  width = 24,
  height = 24,
  color = '#003087',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5859 6H13C12.4477 6 12 5.55228 12 5C12 4.44772 12.4477 4 13 4H19C19.5523 4 20 4.44772 20 5V11C20 11.5523 19.5523 12 19 12C18.4477 12 18 11.5523 18 11V7.41429L9.70722 15.7071C9.3167 16.0976 8.68353 16.0976 8.29301 15.7071C7.90248 15.3165 7.90248 14.6834 8.29301 14.2929L16.5859 6Z"
        fill={color}
      />
      <path
        d="M4 8.00001C4 7.44772 4.44772 7.00001 5 7.00001H11C11.5523 7.00001 12 7.44772 12 8.00001C12 8.55229 11.5523 9.00001 11 9.00001H6V18H15V13C15 12.4477 15.4477 12 16 12C16.5523 12 17 12.4477 17 13V19C17 19.5523 16.5523 20 16 20H5C4.44772 20 4 19.5523 4 19V8.00001Z"
        fill={color}
      />
    </svg>
  )
}
